import "../main.css"
import React from "react"
import "@fontsource/roboto"
import Login from "./Login"
import { Container } from "react-bootstrap"
import NotificationToaster from "./NotificationToaster"
import Dashboard from "../../Component/Dashboard/Dashboard"
import UsersManager from "../../Component/User/UsersManager"
import Navigation from "./Navigation"
import ForgotPassword from "./ForgotPassword"
import Todo from "../../Component/Todo/Todo"
import withHooks from "./WithHooks"
import Splash from "../../ComponentPublic/Splash/Splash"
import PlantsManager from "../../Component/Plant/PlantsManager"
import GgPlantsManager from "../../ComponentPublic/GgPlant/GgPlantsManager"
import FamiliesManager from "../../Component/Family/FamiliesManager"
import CharacTypesManager from "../../Component/CharacType/CharacTypesManager"
import CharacteristicsManager from "../../Component/Characteristic/CharacteristicsManager"

class MainApp extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.pylog = this.props.router.params.pylog
    this.dMgr.debug("pylog:", this.pylog)

    this.forgot_password_token = this.props.router.params.forgot_password_token
    this.dMgr.debug("forgot_password_token:", this.forgot_password_token)

    this.state = {
      loggedIn: false,
      entityPage: this.props.entityPage,
      pageType: this.props.pageType !== undefined ? this.props.pageType : "list",
      pageMenu: this.props.pageMenu,
      entityId: this.props.router.params.id !== undefined ? parseInt(this.props.router.params.id) : undefined,
      show: false,
      splashFilterBrightness: 100,
    }
    this.dMgr.debug("init_state:", this.state)

    this.loggedInHandler = this.loggedInHandler.bind(this)
    this.goTo = this.goTo.bind(this)
    this.setSplashFilterBrightness = this.setSplashFilterBrightness.bind(this)
  }

  loggedInHandler() {
    this.dMgr.debug("loggedInHandler:", true)
    this.setState({ loggedIn: true })
  }

  goTo(eventKey) {
    window.history.replaceState(null, null, "/" + eventKey)
    this.setState({ entityPage: eventKey })
  }

  setSplashFilterBrightness(splashFilterBrightness) {
    this.setState({ splashFilterBrightness })
  }

  getDisplayedPage() {
    this.dMgr.debug("getDisplayedPage:", this.state.entityPage)

    switch (this.state.entityPage) {
      default:
      case "splash":
        return <Splash setSplashFilterBrightness={this.setSplashFilterBrightness} />
      case "ggplants":
        return <GgPlantsManager setSplashFilterBrightness={this.setSplashFilterBrightness} entityId={this.state.entityId} />
      case "dashboard":
        return <Dashboard />
      case "plants":
        return <PlantsManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "families":
        return <FamiliesManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "characteristics":
        return <CharacteristicsManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "charac_types":
        return <CharacTypesManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "users":
        return <UsersManager pageType={this.state.pageType} entityId={this.state.entityId} />
      case "todo":
        return <Todo />
    }
  }

  render() {
    this.dMgr.rendering()
    this.dMgr.debug("getDisplayedPage", this.state.entityPage)

    if (this.state.entityPage === "splash") {
      document.body.style.backgroundColor = "black"

      let toRender = (
        <>
          <div className="background-wrapper">
            <div className={"splash-img filter-brightness-" + this.state.splashFilterBrightness}></div>
            <div className="content-wrapper">
              <Container className="min-height-100vh d-flex flex-column justify-content-center">{this.getDisplayedPage()}</Container>
            </div>
          </div>
          <NotificationToaster />
        </>
      )
      this.dMgr.renderDone()
      return toRender
    } else if (this.state.entityPage === "forgot_password") {
      let variantPage
      if (this.forgot_password_token === undefined) {
        variantPage = "request"
      } else {
        variantPage = "reset"
      }
      this.dMgr.debug("ForgotPassword redirection ", variantPage, this.forgot_password_token)
      return <ForgotPassword variantPage={variantPage} token={this.forgot_password_token} />
    } else if (!this.state.loggedIn) {
      this.dMgr.debug("Not logged in: redirection")

      let autoPyLog = false
      if (this.state.entityPage === "ggplants") {
        autoPyLog = true
      }

      this.dMgr.debug("NautoPyLog: ", autoPyLog)

      return <Login loggedInHandler={this.loggedInHandler} pylog={this.pylog} autoPyLog={autoPyLog} />
    } else if (this.pylog !== undefined) {
      this.dMgr.debug("Pylog: redirection")
      window.location = "/"
      return null
    } else if (this.state.entityPage === "ggplants") {
      document.body.style.backgroundColor = "black"

      let toRender = (
        <>
          <div className="background-wrapper">
            <div className={"splash-img filter-brightness-" + this.state.splashFilterBrightness}></div>
            <div className="content-wrapper">
              <Container className="min-height-100vh d-flex flex-column ">{this.getDisplayedPage()}</Container>
            </div>
          </div>
          <NotificationToaster />
        </>
      )
      this.dMgr.renderDone()
      return toRender
    } else {
      let toRender = (
        <>
          <Navigation changeLanguage={this.props.changeLanguage} pageType={this.state.pageType} pageMenu={this.state.pageMenu} />
          <Container fluid className="main-container">
            {this.getDisplayedPage()}
          </Container>
          <NotificationToaster />
        </>
      )

      this.dMgr.renderDone()
      return toRender
    }
  }
}

export default withHooks(MainApp)
